/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientContacts = sqliteTable('patient_contacts', {
  id: text('id').primaryKey().notNull(),
  patient_id: text('patient_id'),
  email: text('email'),
  mobile_country_code: text('mobile_country_code'),
  mobile_number: text('mobile_number'),
  formal_telephone: text('formal_telephone'),
  formal_postal_code: text('formal_postal_code'),
  formal_unit: text('formal_unit'),
  formal_residential_address: text('formal_residential_address'),
  formal_residential_address_local: text('formal_residential_address_local'),
  formal_province_state: text('formal_province_state'),
  formal_district: text('formal_district'),
  formal_sub_district: text('formal_sub_district'),
  present_telephone: text('present_telephone'),
  present_postal_code: text('present_postal_code'),
  present_unit: text('present_unit'),
  present_address: text('present_address'),
  present_address_local: text('present_address_local'),
  present_province_state: text('present_province_state'),
  present_district: text('present_district'),
  present_sub_district: text('present_sub_district'),
  office_telephone: text('office_telephone'),
  office_address: text('office_address'),
});
